import { endOfDay, format, setHours, setMilliseconds, setMinutes, setSeconds, subDays } from "date-fns";

// ----------------------------------------------------------------------

export function getTrailEndDate() {
    const toDayTime = Math.round(new Date(new Date().toLocaleDateString()).getTime());
    const endDayTime = toDayTime + ( 29 * 24 * 3600 * 1000 );

    return format(new Date(endDayTime).setHours(0, 0, 0, 0), "MMMM dd yyyy");
}

export function getNextBillingDate(date) {
    if (!date) return "";

    const lastDayTime = Math.round(new Date(new Date(date).toLocaleDateString()).getTime());
    const nextDayTime = lastDayTime + ( 24 * 3600 * 1000 );

    return format(new Date(nextDayTime).setHours(0, 0, 0, 0), "MMMM dd, yyyy");
}

export function getTodayDate() {
    const start = new Date();
    start.setHours(0, 0, 0, 0); // Set to local midnight
    const utcStart = new Date(start.getTime() + start.getTimezoneOffset() * 60 * 1000);

    const end = new Date(start.getTime() + 24 * 3600 * 1000); // Add 24 hours
    const utcEnd = new Date(end.getTime() + end.getTimezoneOffset() * 60 * 1000);

    return {
        startTime: format(utcStart, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        endTime: format(utcEnd, "yyyy-MM-dd'T'HH:mm:ss'Z'")
    };
}

export function getLast24hDate() {
    const current = new Date(); // Current time
    const last24h = new Date(current.getTime() - 24 * 3600 * 1000); // 24 hours ago

    const utcStart = new Date(last24h.getTime() + last24h.getTimezoneOffset() * 60 * 1000);
    const utcEnd = new Date(current.getTime() + current.getTimezoneOffset() * 60 * 1000);

    return {
        startTime: format(utcStart, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        endTime: format(utcEnd, "yyyy-MM-dd'T'HH:mm:ss'Z'")
    };
}

export function getPreviousDays(n) {
    const today = new Date(); // Current date
    today.setHours(0, 0, 0, 0); // Set to local midnight

    // Calculate the start of the range
    const previousDay = new Date(today.getTime() - n * 24 * 3600 * 1000);

    // Adjust to UTC
    const utcStart = new Date(previousDay.getTime() + previousDay.getTimezoneOffset() * 60 * 1000);
    const utcEnd = new Date(today.getTime() + today.getTimezoneOffset() * 60 * 1000);

    return {
        startTime: format(utcStart, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        endTime: format(utcEnd, "yyyy-MM-dd'T'HH:mm:ss'Z'")
    };
}

export function getPreviousYears(n) {
    const currentYear = new Date().getFullYear(); // Current year
    const startYear = currentYear - ( n - 1 ); // Calculate the starting year

    // Start of the range (January 1st of startYear)
    const startOfYear = new Date(startYear, 0, 1);
    // End of the range (January 1st of the next year)
    const endOfYear = new Date(startYear + 1, 0, 1);

    const utcStart = new Date(startOfYear.getTime() + startOfYear.getTimezoneOffset() * 60 * 1000);
    const utcEnd = new Date(endOfYear.getTime() + endOfYear.getTimezoneOffset() * 60 * 1000);

    return {
        startTime: format(utcStart, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        endTime: format(utcEnd, "yyyy-MM-dd'T'HH:mm:ss'Z'")
    };
}

export function getCustomUTCDate(date) {
    if (!date) return null; // Handle invalid input

    const customDate = new Date(date);
    const utcDate = new Date(customDate.getTime() + customDate.getTimezoneOffset() * 60 * 1000);

    return format(utcDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
}

export function getCustomDate(date) {
    if (!date) return null; // Handle invalid input

    const customDate = new Date(date);

    return format(customDate, "yyyy-MM-dd'T'HH:mm:SSxxx");
}

export function getAppointedDate(dateSelection, date) {
    let tempTime = { startTime: "", endTime: "" };

    switch (dateSelection) {
        case "all":
            tempTime = {
                startTime: null,
                endTime: null
            };
            break;
        case "today":
            tempTime = getTodayDate();
            break;
        case "last24h":
            tempTime = getLast24hDate();
            break;
        case "last7d":
            tempTime = getPreviousDays(7);
            break;
        case "last30d":
            tempTime = getPreviousDays(30);
            break;
        case "last45d":
            tempTime = getPreviousDays(45);
            break;
        case "this1y":
            tempTime = getPreviousYears(1);
            break;
        case "this2y":
            tempTime = getPreviousYears(2);
            break;
        case "this3y":
            tempTime = getPreviousYears(3);
            break;
        case "custom":
            tempTime = {
                startTime: getCustomUTCDate(date.startDate),
                endTime: getCustomUTCDate(endOfDay(new Date(date.endDate)))
            };
            break;
        default:
            break;
    }

    return tempTime;
}

// export function formatDeliveryDate(dateString) {
//     const dateObj = new Date(dateString);
//
//     const options = { weekday: 'long' }; // 获取周几
//
//     const dayOfWeek = dateObj.toLocaleDateString('en-US', options);
//
//     return `${dayOfWeek} (${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')})`;
// }

// export function formatDeliveryDate(dateString) {
//     if (!dateString) return ""; // Handle invalid input gracefully
//
//     const dateObj = new Date(dateString);
//     if (Number.isNaN(dateObj.getTime())) return ""; // Handle invalid date strings
//
//     // Using Intl.DateTimeFormat for consistent formatting
//     const formatter = new Intl.DateTimeFormat('en-US', { weekday: 'long' });
//     const dayOfWeek = formatter.format(dateObj);
//
//     const month = ( dateObj.getMonth() + 1 ).toString().padStart(2, '0'); // Month
//     const date = dateObj.getDate().toString().padStart(2, '0'); // Day
//
//     return `${dayOfWeek} (${month}/${date})`;
// }

export function formatDeliveryDate(dateString) {
    if (!dateString) return "";

    // 手动解析 ISO 格式日期 (兼容旧系统)
    const parts = String(dateString).split(/\D+/).map(Number);
    if (parts.length < 3) return ""; // 无效格式

    // 注意: 月份需要减 1 (JavaScript 月份从 0 开始)
    const dateObj = new Date(parts[0], parts[1] - 1, parts[2]);
    if (Number.isNaN(dateObj.getTime())) return "";

    // 使用 UTC 模式避免时区问题
    const formatter = new Intl.DateTimeFormat("en-US", { weekday: "long", timeZone: "UTC" });
    const dayOfWeek = formatter.format(dateObj);

    const month = ( dateObj.getMonth() + 1 ).toString().padStart(2, "0");
    const date = dateObj.getDate().toString().padStart(2, "0");

    return `${dayOfWeek} (${month}/${date})`;
}
export function getPrevious30DaysLocalMidnightDate() {
    return format(setMilliseconds(setSeconds(setMinutes(setHours(subDays(new Date(), 30), 0), 0), 0), 0), "yyyy-MM-dd'T'HH:mm:ssXXX")
}

export function getPreviousLocalEndOfDayDate() {
    return format(setMilliseconds(setSeconds(setMinutes(setHours(subDays(new Date(), 1), 23), 59), 59), 999), "yyyy-MM-dd'T'HH:mm:ssXXX")
}
export function getTodayLocalEndOfDayDate() {
    return format(
      setMilliseconds(
        setSeconds(
          setMinutes(
            setHours(new Date(), 23),
          59),
        59),
      999),
      "yyyy-MM-dd'T'HH:mm:ssXXX"
    );
  }


export function formatDateToUS(dateStr) {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  return `${month}/${day}/${year}`;
}